import { CommonModule } from '@angular/common';
import { Component, HostListener, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-popover',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './popover.component.html',
    styleUrl: './popover.component.scss',
})
export class PopoverComponent implements OnInit {
    @Input() onClick?: (e: Event) => void;
    collapsed: boolean = true;
    screenW: number = 0;
    screenH: number = 0;
    triangeWidth = 23;

    ngOnInit(): void {
        this.updateScreenSize();
    }

    @HostListener('window:resize', ['$event'])
    onResize(_: Event) {
        this.updateScreenSize();
    }

    updateScreenSize() {
        this.screenH = window.innerHeight;
        this.screenW = window.innerWidth;
    }

    onclick = (e: Event) => {
        this.collapsed = !this.collapsed;
        if (this.onClick) this.onClick(e);
    };

    get ngStyle() {
        return {
            "height": this.screenH,
            "width": this.screenW,
        }
    }
}
